import React from 'react';
import { useSelector } from 'react-redux';

import { selectCrossLinks, selectIsSeoCrossLinksV2Enabled } from '../../../selectors/seoCrossLinks';
import { SeoCrossLinks } from '../../components/SeoCrossLinks';

export function SeoCrossLinksContainer() {
  const crossLinks = useSelector(selectCrossLinks);
  const isCrossLinksV2Enabled = useSelector(selectIsSeoCrossLinksV2Enabled);

  if (!crossLinks || !crossLinks.length || isCrossLinksV2Enabled) {
    return null;
  }

  return <SeoCrossLinks seoBlocks={crossLinks} />;
}
